/**
 * studentPasswordAdapter — « Mot de passe » et « Fermer mon compte ».
 *
 * Le mot de passe : port du schéma `yup` d'`UpdatePasswordScreen.js` (les trois champs obligatoires,
 * huit caractères au moins, la confirmation égale) et de son corps (`authService.updatePassword`),
 * avec les refus du serveur (`current_password`, `password`) remis sous leur champ.
 *
 * La fermeture : l'avis d'abonnement de `DeleteAccountScreen.js`, tel quel — il ne connaît que
 * PREMIUM et PLUS, pas les offres plus récentes.
 */
import { type UIPasswordChange } from "../../../ui/types/studentAccount"
import { laravelFieldErrors } from "../shared/laravelFieldErrors"
import { hasRole } from "./studentAccountAdapter"
import { REQUIRED_MESSAGE } from "./studentSettingsAdapter"

export const EMPTY_PASSWORD_CHANGE: UIPasswordChange = { currentPassword: "", password: "", passwordConfirmation: "" }

export type PasswordChangeErrors = Partial<Record<keyof UIPasswordChange, string>>

export function validatePasswordChange(values: UIPasswordChange): PasswordChangeErrors {
    const errors: PasswordChangeErrors = {}
    if (values.currentPassword === "") errors.currentPassword = REQUIRED_MESSAGE
    if (values.password === "") errors.password = REQUIRED_MESSAGE
    else if (values.password.length < 8) errors.password = "Le mot de passe doit contenir 8 caractères minimum"
    if (values.passwordConfirmation === "") errors.passwordConfirmation = REQUIRED_MESSAGE
    else if (values.passwordConfirmation !== values.password) {
        errors.passwordConfirmation = "Le mot de passe de confirmation ne correspond pas"
    }
    return errors
}

export function toPasswordPayload(values: UIPasswordChange) {
    return {
        current_password: values.currentPassword,
        password: values.password,
        password_confirmation: values.passwordConfirmation,
    }
}

const PASSWORD_FIELD_BY_API_KEY: Record<string, keyof UIPasswordChange> = {
    current_password: "currentPassword",
    password: "password",
    password_confirmation: "passwordConfirmation",
}

/** Les refus de champ du serveur (422), sous leur champ. */
export function passwordFieldErrors(error: unknown): PasswordChangeErrors {
    const fields: PasswordChangeErrors = {}
    for (const [key, message] of Object.entries(laravelFieldErrors(error))) {
        const field = PASSWORD_FIELD_BY_API_KEY[key]
        if (field && !fields[field]) fields[field] = message
    }
    return fields
}

/** « Ton abonnement Masteur PREMIUM est encore valable » — seulement PREMIUM et PLUS, comme avant. */
export function closeAccountActiveOffer(user: { roles?: string[] } | null | undefined): string | null {
    if (hasRole(user, "premium-student")) return "PREMIUM"
    if (hasRole(user, "plus-student")) return "PLUS"
    return null
}
